import { useEffect, useRef } from 'react';
import { registerBackHandler } from '../utils/backButtonRegistry';

/**
 * Register a back handler while `active` is true. When the Android hardware /
 * gesture back button is pressed, the most recently registered active handler
 * runs first (LIFO), letting the top-most overlay close instead of exiting the
 * app or navigating the underlying view.
 *
 * @param {boolean} active  Whether this handler should currently intercept back.
 * @param {Function} onBack Called on back press (e.g. closes the overlay).
 */
export function useBackButton(active, onBack) {
  const onBackRef = useRef(onBack);
  onBackRef.current = onBack;

  useEffect(() => {
    if (!active) return undefined;
    return registerBackHandler(() => {
      const fn = onBackRef.current;
      if (typeof fn === 'function') {
        fn();
        return true;
      }
      return false;
    });
  }, [active]);
}

export default useBackButton;
